export enum EProductImageType {
    CUTTING_AREA_RECTO = 'CUTTING_AREA_RECTO',
    CUTTING_AREA_VERSO = 'CUTTING_AREA_VERSO',
    HELP_GRID_RECTO = 'HELP_GRID_RECTO',
    HELP_GRID_VERSO = 'HELP_GRID_VERSO',
}
